module.exports = __webpack_public_path__ + "static/media/emp_sample_excel.f8fdd076.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/sample/emp_sample_excel.JPG
// module id = 1451
// module chunks = 1